const DEV_PORTS = ['4792', '5173', '6006', '6007', '3000'];

export const isLocalDevelopment = (): boolean => {
    const hostname = window.location.hostname;
    const port = window.location.port;
    return hostname === 'localhost' && DEV_PORTS.includes(port);
};

export const isIframeMode = (): boolean => {
    if (typeof window === 'undefined') return false;
    try {
        return window.location !== window.parent.location;
    } catch {
        return true;
    }
};

export const isStandaloneMode = (): boolean => {
    return !isLocalDevelopment() && !isIframeMode();
};

export const isPreprodEnvironment = (): boolean => {
    try {
        if (document.referrer && document.referrer.includes('preprodgo.accessacloud.com')) {
            return true;
        }
    } catch {
        // ignore cross-origin errors
    }

    // Fallback: check own hostname for preprod patterns
    // (document.referrer may be empty due to Referrer-Policy in cross-origin iframes)
    const hostname = window.location.hostname;
    if (hostname.includes('preprod') && hostname.endsWith('.accessacloud.com')) {
        return true;
    }

    return false;
};

/**
 * Returns true when the EVO platform context is genuinely available.
 * The app must be running inside an iframe AND must not be in a local
 * development environment where the EVO host is absent.
 * Preprod is included because it runs inside the EVO platform iframe
 * and needs real token retrieval.
 */
export const isEvoPlatformAvailable = (): boolean => {
    // return isIframeMode() && !isLocalDevelopment();
    return isIframeMode();
};
